import type { FC } from 'react'
import { memo } from 'react'
import { useState } from 'react'

import { Button } from '@app/components/ui/button'
import { toaster } from '@app/components/ui/toaster'
import { useGoogleAnalyticsPropertyImportMutation } from '@graphql/queries'
import type { GoogleIntegration } from '@graphql/types'

type GoogleProperty = {
  id: string
  display_name: string
}

type Props = {
  integration: Pick<GoogleIntegration, 'id'>
  property: GoogleProperty
}

const ImportPropertyMetricsButton: FC<Props> = ({ integration, property }) => {
  const [disabled, setDisabled] = useState(false)
  const [loading, setLoading] = useState(false)
  const [, importProperties] = useGoogleAnalyticsPropertyImportMutation()

  const onClick = async (e) => {
    e.preventDefault()
    setDisabled(true)

    try {
      await importProperties({
        input: {
          integrationId: integration.id,
          propertyId: property.id,
          propertyName: property.display_name
        }
      })

      toaster.create({
        title: 'Import started',
        description: 'Importing will begin momentarily. Please check your metrics shortly.'
      })
    } catch (error) {
      toaster.create({
        title: 'Error importing metrics',
        type: 'error',
        description: error.message
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Button disabled={disabled} loading={loading} onClick={onClick}>
      Import metrics
    </Button>
  )
}

export default memo(ImportPropertyMetricsButton)
